/**
 * Patch objects use `undefined` to mean "field not intentionally changed," matching the
 * backend's merge-patch semantics (see docs/backend-findings.md). Strip those keys before
 * merging so `exactOptionalPropertyTypes` sees only fields that are actually present.
 */
export function withoutUndefined<T extends object>(value: T): T {
  const entries = Object.entries(value).filter(([, v]) => v !== undefined);
  return Object.fromEntries(entries) as T;
}
